import { useMemo } from 'react';
import {
  AsinCell,
  CurrencyCell,
  PercentCell,
  ProductCell,
  ProgressCell,
} from 'src/components/cells';
import type { ITopProductPerformanceTableData } from 'src/queries/useTopProductPerformance';
import { useTopProductPerformance } from 'src/queries/useTopProductPerformance';
import type { FrontTableColumn, FrontTableProps } from 'src/ui-components';

import { useTopProductsStore } from '../store/store';

export const useTableData = (): FrontTableProps<ITopProductPerformanceTableData> => {
  const { tab } = useTopProductsStore();
  const { data, isLoading } = useTopProductPerformance({
    order: tab,
    top: 5,
  });

  const columns: FrontTableColumn<ITopProductPerformanceTableData>[] = [
    {
      headerName: 'NAME',
      field: 'name',
      flex: 1,
      minWidth: 150,
      renderCell: (d) => <ProductCell {...d.row} />,
    },
    {
      headerName: 'ASIN',
      field: 'asin',
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }) => (
        <AsinCell asin={row.asin?.[0]?.asin || ''} asinLink={row.asin?.[0]?.asinLink} />
      ),
    },
    {
      headerName: '% OF TOTAL SALES ',
      field: 'pct_brand_total_sales',
      flex: 2,
      minWidth: 200,
      renderCell: ({ value }) => <ProgressCell value={value} />,
    },
    {
      headerName: 'SALES $',
      field: 'total_sales',
      flex: 1,
      minWidth: 150,
      type: 'number',
      renderCell: ({ value }) => <CurrencyCell value={value} />,
    },
    {
      headerName: 'YoY GROWTH %',
      field: 'previous_year_change_pct',
      flex: 1,
      minWidth: 150,
      type: 'number',
      renderCell: ({ value }) => <PercentCell value={value} colored decimal />,
    },
  ];

  const tableData: ITopProductPerformanceTableData[] = useMemo(() => {
    return data?.data.tableData.map((r) => ({ ...r, id: r.index })) || [];
  }, [data?.data.tableData]);

  return {
    columns,
    loading: isLoading,
    data: tableData,
    rowHeight: 56,
    disableColumnMenu: true,
    disableColumnSorting: true,
    sizeStyles: {
      minHeight: '200px',
    },
  };
};
